<template>
    <main class="app-main app-main--search view">
        <transition name="vignette-transition">
            <div class="pane-vignette pane-vignette--search" v-if="showVignette" @click="onVignetteClick"></div>
        </transition>
        <section :class="['pane pane--search pane--start', visibleClass('search')]" v-if="showPane('search')">
            <slot name="search-pane" />
        </section>
        <section :class="['pane pane--results', visibleClass('results')]" v-if="showPane('results')">
            <slot name="results-pane" />
        </section>
        <section :class="[previewPaneClass, 'pane', 'pane--preview', 'pane--end', previewFullWidth ? 'pane--full-width' : null, visibleClass('preview')]" v-if="showPane('preview')">
            <slot name="preview-pane" />
        </section>
    </main>
</template>

<script>
    export default {
        name: 'pane-view',
        props: ['tools', 'viewKey', 'currentApp', 'panes', 'previewPaneClass'],
        computed: {
            viewData() {
                return this.tools.currentView.data;
            },
            hide() {
                return this.viewData.hide;
            },
            previewFullWidth() {
                return !this.showPane('search') && !this.showPane('results');
            },
            showVignette() {
                return this.tools.currentApp.panes.search || this.tools.currentApp.panes.preview;
            }
        },
        watch: {
            // viewData(val) {
            //     // Toggle panes depending on view data
            //     if (val.showPanes) {
            //         val.showPanes.forEach((key) => {
            //             console.log('what', key);
            //             this.tools.actions.togglePane(key, true);
            //         });
            //     }
            // },
        },
        methods: {
            onVignetteClick() {
                this.tools.actions.togglePane('search', false);
                this.tools.actions.closePreviewPane();
            },
            showPane(key) {
                const hide = this.hide;

                if (hide && hide[key] === true) {
                    return false;
                }

                return true;
            },
            visibleClass(key)
             {
                const { currentApp } = this.tools;
                if (currentApp && currentApp.panes && currentApp.panes[key] === false) {
                    return 'is-hidden';
                }

                return 'is-visible';
            },
        },
    };
</script>

<style>

.pane-vignette {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, .1);
    z-index: 3;
}

@media (min-width:1200px){
    .pane-vignette {
        display:none;
    }
}

.pane-vignette--search {
    opacity: 0;
    z-index: 0;
}

section.pane {
    display: flex;
    flex-flow: column nowrap;
    position: relative;
    z-index: 1;
    height: 100%;
    overflow: hidden;
}
section.pane.is-hidden {
  border: none;
  overflow: hidden;
}
section.pane.pane--start {
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
}
section.pane.pane--start.is-visible {
  border-right: 1px solid rgba(0,0,0,0.2);
}
section.pane.pane--end {
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
}
section.pane.pane--end.is-visible {
  border-left: 1px solid rgba(0,0,0,0.2);
}
section.pane.pane--search {
  background: #fff;
  position: relative;
  z-index: 10;
}
section.pane.pane--search .pane__header,
section.pane.pane--search .pane__body {
  min-width: 200px;
}
@media (min-width: 1201px) {
  section.pane.pane--search {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    overflow-x: hidden;
    -webkit-transition: opacity 0.3s, box-shadow 0.3s, -webkit-flex-basis 0.3s ease-out;
    transition: opacity 0.3s, box-shadow 0.3s, -webkit-flex-basis 0.3s ease-out;
    transition: flex-basis 0.3s ease-out, opacity 0.3s, box-shadow 0.3s;
    transition: flex-basis 0.3s ease-out, opacity 0.3s, box-shadow 0.3s, -webkit-flex-basis 0.3s ease-out, -ms-flex-preferred-size 0.3s ease-out;
    box-shadow: 0 0 0 rgba(0,0,0,0);
  }

  section.pane.pane--search.is-visible {
    -webkit-box-flex: 0;
        -ms-flex: 0 0 200px;
            flex: 0 0 200px;
  }
  section.pane.pane--search.is-hidden {
    -webkit-box-flex: 0;
        -ms-flex: 0 0 0px;
            flex: 0 0 0px;
  }
}
@media (max-width: 1200px) {
  section.pane.pane--search {
    position: absolute;
    top: 0;
    left: 0;
    width: 200px;
    -webkit-transition: opacity 0.3s, box-shadow 0.3s, -webkit-transform 0.3s;
    transition: opacity 0.3s, box-shadow 0.3s, -webkit-transform 0.3s;
    transition: transform 0.3s, opacity 0.3s, box-shadow 0.3s;
    transition: transform 0.3s, opacity 0.3s, box-shadow 0.3s, -webkit-transform 0.3s;
    box-shadow: 0 0 10px rgba(0,0,0,0.2);
  }
  section.pane.pane--search.is-visible {
    -webkit-transform: translatex(0);
            transform: translatex(0);
    opacity: 1;
  }
  section.pane.pane--search.is-hidden {
    -webkit-transform: translatex(-100%);
            transform: translatex(-100%);
    opacity: 0;
  }
  .pane-vignette--search {
      opacity: 1;
      z-index: 4;
  }
}
@media (max-width: 800px) {
  section.pane.pane--search {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    -webkit-transition: -webkit-transform 0.3s;
    transition: -webkit-transform 0.3s;
    transition: transform 0.3s;
    transition: transform 0.3s, -webkit-transform 0.3s;
  }

  section.pane.pane--search.is-visible {
    -webkit-transform: translatex(0);
            transform: translatex(0);
            box-shadow: 0 0 10px rgba(0,0,0,0.2);
            opacity:1;
  }
  section.pane.pane--search.is-hidden {
    -webkit-transform: translatex(-100%);
            transform: translatex(-100%);
            box-shadow: 0 0 10px rgba(0,0,0,0);
            opacity:0;
  }
}
section.pane.pane--results {
    flex: 1 0 0;
    z-index: 2;
}
section.pane.pane--preview {
  background: #fff;
  z-index: 5;
}
section.pane.pane--preview .pane__header,
section.pane.pane--preview .pane__body {
  width: 600px;
}
@media (min-width: 1201px) {
  section.pane.pane--preview {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    overflow-x: hidden;
    -webkit-transition: opacity 0.3s, box-shadow 0.3s, -webkit-flex-basis 0.3s ease-out;
    transition: opacity 0.3s, box-shadow 0.3s, -webkit-flex-basis 0.3s ease-out;
    transition: flex-basis 0.3s ease-out, opacity 0.3s, box-shadow 0.3s;
    transition: flex-basis 0.3s ease-out, opacity 0.3s, box-shadow 0.3s, -webkit-flex-basis 0.3s ease-out, -ms-flex-preferred-size 0.3s ease-out;
    box-shadow: 0 0 0 rgba(0,0,0,0);
  }
  section.pane.pane--preview.is-visible {
    -webkit-box-flex: 0 0 600px;
        -ms-flex: 0 0 600px;
            flex: 0 0 600px;
  }
  section.pane.pane--preview.is-hidden {
    -webkit-box-flex: 0 0 0;
        -ms-flex: 0 0 0;
            flex: 0 0 0;
  }
}
@media (max-width: 1200px) {
  section.pane.pane--preview.pane-width-800 {
     width: 800px;
  }
  section.pane.pane--preview {
    position: absolute;
    top: 0;
    right: 0;
    width: 600px;
    -webkit-transition: opacity 0.3s, box-shadow 0.3s, -webkit-transform 0.3s;
    transition: opacity 0.3s, box-shadow 0.3s, -webkit-transform 0.3s;
    transition: transform 0.3s, opacity 0.3s, box-shadow 0.3s;
    transition: transform 0.3s, opacity 0.3s, box-shadow 0.3s, -webkit-transform 0.3s;
    box-shadow: 0 0 10px rgba(0,0,0,0.2);
  }
  section.pane.pane--preview.is-visible {
    -webkit-transform: translatex(0);
            transform: translatex(0);
    opacity: 1;
    box-shadow: 0 0 10px rgba(0,0,0,0.2);
  }
  section.pane.pane--preview.is-hidden {
    -webkit-transform: translatex(100%);
            transform: translatex(100%);
    opacity: 0;
    box-shadow: 0 0 10px rgba(0,0,0,0);
  }
}
@media (max-width: 800px) {
  section.pane.pane--preview {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    z-index: 4;
    transition: transform 0.3s;
  }
  section.pane.pane--preview.is-visible {
            transform: translatex(0%);
            z-index: 6;
  }
  section.pane.pane--preview.is-hidden {
            transform: translatex(0);
  }
  section.pane.pane--results {
      z-index: 5;
  }
}

input.pane__search-bar {
    width: calc(100% - 20px);
    /*margin-bottom: 15px;*/
    /*margin:15px;*/
    margin:10px 10px 5px 10px;
}

section.pane.pane--full-width {
    width: 100%;
    flex: auto !important;
    transform: translatex(0) !important;
}

.vignette-transition-enter-to,
.vignette-transition-leave {
    opacity:1;
    transition:opacity .7s;
}
.vignette-transition-enter,
.vignette-transition-leave-to {
    opacity:0;
    transition:opacity .2s;
}

/**
 * Pane sizing
 */

    section.pane.is-visible.pane-width-800 {
        flex: 0 0 800px;
    }

/**
 * Sticky pane header
 */

    .pane-template.sticky-header .pane-header {
        position: absolute;
        top: 0;
        background: #FFF;
    }

    .pane-template.sticky-header {
        padding-top: 44px;
    }
</style>



// WEBPACK FOOTER //
// PaneView.vue?9ff8423e